document.addEventListener("DOMContentLoaded", function () {
  const stepTabs = document.querySelectorAll(".step-tab");
  const stepContents = document.querySelectorAll(".step-content");

  if (!stepTabs.length || !stepContents.length) return;

  stepTabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const targetStepId = this.getAttribute("data-step");

      stepTabs.forEach((t) => t.classList.remove("active"));
      stepContents.forEach((content) => content.classList.remove("active"));

      this.classList.add("active");

      const targetContent = Array.from(stepContents).find(
        (content) => content.getAttribute("data-content") === targetStepId,
      );

      if (targetContent) {
        targetContent.classList.add("active");
      }
    });
  });
});

